import React from 'react';

export default function About(){
    return(
        <div>
            <p>Hola mundo esto es el about</p>
        </div>
    )
}